import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana75Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1462_13738)"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M586.795 634.452L572.398 603.042L526.592 625.291L544.914 663.245L582.868 644.922C588.103 642.828 587.667 637.07 586.795 634.452Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M506.958 681.569L544.912 663.247L526.59 625.293L480.783 647.542L493.871 675.026C497.012 682.355 503.905 682.442 506.958 681.569Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M555.385 566.397L572.399 603.043L526.592 625.291L509.579 588.646L555.385 566.397Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M480.784 647.542L526.59 625.294L509.576 588.648L463.77 610.897L480.784 647.542Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M445.445 571.634L463.767 610.896L508.265 588.647L491.251 549.385L445.445 571.634Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M538.367 529.751L492.561 552L508.266 588.645L555.381 566.396L538.367 529.751Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M521.355 493.107L538.369 529.753L492.563 552.001L474.24 514.048L521.355 493.107Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M427.124 533.68L445.447 571.634L491.253 549.386L472.93 511.432L427.124 533.68Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M410.111 495.725L427.125 533.679L472.932 511.43L454.609 473.477L410.111 495.725Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M503.034 455.154L457.227 478.712L474.241 514.048L521.356 493.108L503.034 455.154Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M486.017 418.509L503.031 455.154L457.224 478.712L438.902 440.758L486.017 418.509Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M391.791 457.772L410.113 495.726L454.611 473.477L436.288 435.523L391.791 457.772Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M467.7 380.556L486.023 418.51L438.907 440.758L421.894 402.805L467.7 380.556Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M373.465 419.816L391.788 457.77L436.286 435.521L419.272 397.567L373.465 419.816Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M356.489 385.863L373.467 419.818L419.273 397.569L404.876 367.468C388.867 371.235 375.187 369.637 368.789 368.008C367.539 367.69 366.258 367.428 364.977 367.576C357.003 368.495 354.94 375.117 354.914 380.179C354.904 382.173 355.597 384.079 356.489 385.863Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <path 
    className="cursor-pointer"
    onClick={(e) => landSelector(e, findLandByLot("1"))}    
    d="M451.408 347.978L467.696 380.554L421.89 402.804L404.876 367.467C419.655 363.526 429.411 353.868 433.056 348.743C433.478 348.148 433.924 347.565 434.467 347.078C440.553 341.609 446.351 343.299 449.44 345.487C450.317 346.109 450.927 347.017 451.408 347.978Z" 
    fill={getFillByLot(1, selected, lands)}  
    fill-opacity="0.64" 
    stroke="#6D6859" 
    stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_13738" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_13738" transform="matrix(0.00179518 0 0 0.00237992 -3.33636 -1.56113)"/>
    </pattern>
    <image id="image0_1462_13738" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};